import React from 'react';
import Text from 'Components/Text';
import Button, { buttonColor } from 'Components/Button';
import { STEP_ID } from 'constants/boatApplication';

export default ({personPowerCapacity, plateType, isFinalReview, goToStep, boatDetailsRequestInProcess}) => {
  if (boatDetailsRequestInProcess) return null;
  if (!personPowerCapacity) return null;
  if (personPowerCapacity.calBoatWeight === undefined) return null;

  return (
    <section className='scene_section'>
      <header>Boat Weight / Plate Type</header>
      {personPowerCapacity.calBoatWeight !== undefined && (
        <Text
          mainWrapperClassName='text__wrapper_primary _margin_right_30'
          textClassName='text__text_primary'
          label='Calculated Boat Weight'
          value={personPowerCapacity.calBoatWeight}
          units=' Lbs.'
          decimalDigits={2}
        />
      )}
      {plateType !== undefined && (
        <Text
          mainWrapperClassName='text__wrapper_primary'
          textClassName='text__text_primary'
          label='Plate Type'
          value={plateType}
          removeUnderlines
        />
      )}
      {isFinalReview && (
        <Button
          color={buttonColor.planeOrange}
          label='Edit'
          buttonClassName='_height_20 _width_60 _position_absolute _right_130 _font_size_14'
          fontSize={14}
          onClick={() => goToStep(STEP_ID.WEIGHT_CAPACITY, true)}
        />
      )}
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/Details/BoatWeight.jsx